window.mcb.forms.files = window.mcb.forms.files || {};
window.mcb.forms.fileReader = function (instanceName, fileField, shared, wrapper, row, input, validateTarget) {
  const _logger = window.mcb.utilities.createLogger("forms.fileReader", 'Forms FileReader');
  const _instance = instanceName;
  const _thisField = fileField;
  const _shared = shared;
  const _wrapper = wrapper;
  const _row = row;
  const _input = input;
  const _validateTarget = validateTarget;
  let _removeButton = null;
  let _reader = null;
  let _data64 = null;
  let _dataIsReady = false;
  let _errorMessageToken = null;
  let _errorMessageCode = null;
  let _validationResult = null;

  let applyError = function () {
    _validationResult = new window.mcb.forms.validation.ValidationResult(false, _errorMessageToken, _errorMessageCode);
    _validationResult.render(_thisField.formId, _wrapper, _validateTarget);
    resetFlags();

    _shared.handleFileUpdate(this);
  };

  function errorHandler(evt) {
    switch (evt.target.error.code) {
      case evt.target.error.NOT_FOUND_ERR:
        _errorMessageToken = 'FileNotFound';
        break;
      case evt.target.error.NOT_READABLE_ERR:
        _errorMessageToken = 'FileNotReadable';
        break;
      case evt.target.error.ABORT_ERR:
        _errorMessageToken = 'FileReadAborted';
        break;
      default:
        _errorMessageToken = 'AnErrorOccurredReadingFile';
        _errorMessageCode = evt.target.error.code;
    }

    applyError();
  }

  function updateProgress(evt) {
    if (evt.lengthComputable) {
      let percentLoaded = Math.round(evt.loaded * 100 / evt.total);
      _logger.trace("Progress: " + percentLoaded + "% for " + _input.files[0].name + " (" + _thisField.alias + ")");
    }
  }

  const validateFile = function (eventTarget) {
    if (eventTarget !== _input) {
      return new window.mcb.forms.validation.ValidationResult(false, "FileControlConflict");;
    }

    const result = new window.mcb.forms.validation.ValidationResult(true);
    if (_input.value !== "") {
      const file = _input.files[0];
      if (file.size === 0) {
        _logger.trace('Violating File Size Empty', _input);
        result.aggregate(new window.mcb.forms.validation.ValidationResult(false, "FileSizeZeroViolation"));
      }
      else if (file.size > _thisField.validation.maxSize) {
        _logger.trace('Violating File Size Max', _input, file.size, _thisField.validation.maxSize);
        result.aggregate(new window.mcb.forms.validation.ValidationResult(false, "FileSizeViolation", _thisField.validation.maxSizeFormatted));
      }

      if (_thisField.validation.whitelist !== null && _thisField.validation.whitelist.length > 0) {
        let type = "_";
        const idot = _input.value.lastIndexOf(".");
        if (idot > 0) {
          type = _input.value.substring(idot + 1).toUpperCase();
        }

        if (_thisField.validation.whitelist.indexOf(type) < 0) {
          _logger.trace('Violating File Type', _input, type);
          result.aggregate(new window.mcb.forms.validation.ValidationResult(false, "FileTypeViolation", _thisField.validation.whitelistFormatted));
        }
      }

      if (_errorMessageToken !== null) {
        _logger.trace('Browser has reported an error', _input, _errorMessageToken);
        result.aggregate(new window.mcb.forms.validation.ValidationResult(false, _errorMessageToken, _errorMessageCode));
      }
    }

    return result;
  }

  const resetFlags = function () {
    _input.classList.remove('loading');
    _input.classList.remove('loaded');
    _data64 = null;
    _dataIsReady = false;
  };

  const resetError = function () {
    _errorMessageToken = null;
    _errorMessageCode = null;
  };

  function handleFileSelect(evt) {
    resetFlags();

    if (_input.files.length === 0) {
      _input.classList.remove('selected');
    }
    else {
      _input.classList.add('selected');
    }

    _validationResult = validateFile(evt.target);
    if (_validationResult.isValid()) {
      resetError();

      const file = evt.target.files[0];

      _logger.trace("Progress: 0% for " + file.name + " (" + _thisField.alias + ")");
      _reader = new FileReader();
      _reader.onerror = errorHandler;
      _reader.onprogress = updateProgress;
      _reader.onabort = function (event) {
        internalHandleFileRemove(event);
      };
      _reader.onloadstart = function (e) {
        _input.classList.add('loading');
      };
      _reader.onload = function (e) {
        _input.classList.remove('loading');
        _input.classList.add('loaded');
      };
      _reader.onloadend = function () {
        _data64 = this.result;
        _dataIsReady = true;

        _shared.handleFileUpdate(this);
      };

      _reader.readAsArrayBuffer(file);
    }
    else {
      resetFlags();
      _shared.handleFileUpdate(this);
    }

    if (_input.value !== "") {
      if (_removeButton === null) {
        const span = document.createElement('span');
        span.classList.add(window.mcb.forms.constants.fields.filelistbutton);

        _removeButton = document.createElement('button');
        _removeButton.type = 'button';
        _removeButton.classList.add(window.mcb.forms.constants.fields.filelistbutton);
        _removeButton.innerHTML = window.mcb.forms.data.getMessageFromToken(_thisField.formId, "deleteFile");
        _removeButton.addEventListener('click', function (event) {
          internalHandleFileRemove(event);
        }, false);

        span.append(_removeButton);
        _row.append(span);
      }
    }
  }

  _input.addEventListener('change', handleFileSelect, false);

  const internalHandleFileRemove = function (event) {
    if (_reader !== null) {
      _reader.abort();
    }

    _removeButton = null;
    _reader = null;
    _data64 = null;
    _dataIsReady = false;
    _errorMessageToken = null;
    _errorMessageCode = null;
    _validationResult = null;

    _shared.handleFileRemove(_instance, this, _wrapper, event);
  };

  return _ = {
    getValue: function (allowValueFormatting = false) {
      const value = {
        isEmpty: _input.files.length === 0,
        isValid: _dataIsReady
      };

      if (_validationResult !== null) {
        _validationResult.render(_thisField.formId, _wrapper, _validateTarget);
        if (!_validationResult.isValid()) {
          value.isValid = false;
        }
      }

      if (!value.isEmpty) {
        value.name = _input.files[0].name;
        value.type = _input.files[0].type;
      }

      if (value.isValid && allowValueFormatting) {
        value.data = _data64;

        value.toArray = function () {
          let _data;
          try {
            _data = Array.from(new Uint8Array(_data64));
          }
          catch (e) {
            _data = [];
            let _t = new Uint8Array(_data64);
            for (let byte of _t) {
              _data.push(byte);
            }
          }

          return _data;
        };

        value.getSize = function () {
          return _data64.byteLength;
        };
      }

      return value;
    },
    isReady: function () {
      return _dataIsReady;
    }
  };
};
